import { setYear } from "date-fns";
import type { UserAuth } from "~/types/entities/auth";

type OnboardingData = {
  email: string;
};

export const useSessionStore = defineStore(
  "user-store",
  () => {
    const processingAuth = ref(false);
    const user = ref<Partial<UserAuth>>({});
    const isLoggedIn = computed<boolean>(() => {
      return !!user.value.accessToken;
    });
    const hasRefreshedSession = ref<boolean>(false);

    const hasCompletedOnboarding = ref<boolean>(false);
    const onboardingData = reactive<Partial<OnboardingData>>({});

    const userData = computed<UserAuth["userInfo"] | undefined>(
      () => user.value.userInfo,
    );

    const activePlan = computed(() => {
      return (
        user.value.userInfo?.currentPlan || {
          id: 1,
          name: "Popular",
          price: "$29",
          isCurrent: true,
          level: 1,
          features: [
            "Ticketing system",
            "  Manual onboarding",
            "OLA (limited)",
            "  SLA (limited)",
            "  Staff strength < 100",
            "Department creation(Limited)",
            "Groups per Department(Limited)",
          ],
          renewalDate: setYear(new Date(), 2026).toISOString(),
        }
      );
    });

    async function refreshUserData() {
      if (!isLoggedIn.value) return;
      const response = await useRequest<{ data: UserAuth }>(
        "auth/login/context",
        {
          method: "GET",
        },
      );
      if (response._data?.data) user.value = response._data.data;
      hasRefreshedSession.value = true;
    }

    async function resetUserData() {
      user.value = {};
      processingAuth.value = false;
      hasRefreshedSession.value = false;
      hasCompletedOnboarding.value = false;
      await nextTick();
    }

    return {
      isLoggedIn,
      user,
      userData,
      hasCompletedOnboarding,
      onboardingData,
      processingAuth,
      hasRefreshedSession,
      activePlan,
      refreshUserData,
      resetUserData,
    };
  },
  {
    persistedState: {
      excludePaths: ["processingAuth", "hasRefreshedSession"],
    },
  },
);
